





























import {Component, Prop, Vue} from 'vue-property-decorator';
import CloseIcon from '../assets/icon-close-x.svg';
import {ConvertModule} from '@/stores/modules/convert';
import {WebService} from '@/services/web.service';

@Component({
	components: {
		CloseIcon: CloseIcon
	}
})
export default class LocationPicker extends Vue {
	@Prop() private msg!: string;
	get locations() {
		return ConvertModule.locations;
	}

	async mounted() {
		await WebService.getLocations();
	}

	selectLocation(locationBase: string) {
		this.$emit('selected-location', locationBase);
	}
}
